import { apiService } from './api';
import { OverviewPayload } from '../types';
export const overviewService = {
  consultant: (mine?: boolean) => apiService.get<OverviewPayload>('/overview/consultant', mine === undefined ? undefined : {mine}),
  client: (id: string) => apiService.get<OverviewPayload>(`/clients/${id}/overview`),
};
